import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../../common/SafeIcon'

const { FiCheck, FiX, FiAlertCircle } = FiIcons

const Toast = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, 3000)

    return () => clearTimeout(timer)
  }, [onClose])

  const getToastStyles = () => {
    switch (type) {
      case 'success':
        return {
          bg: 'bg-green-500',
          icon: FiCheck,
          iconColor: 'text-white'
        }
      case 'error':
        return {
          bg: 'bg-red-500',
          icon: FiAlertCircle,
          iconColor: 'text-white'
        }
      default:
        return {
          bg: 'bg-blue-500',
          icon: FiCheck,
          iconColor: 'text-white'
        }
    }
  }

  const styles = getToastStyles()

  return (
    <motion.div
      initial={{ opacity: 0, y: -50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -50, scale: 0.9 }}
      className={`fixed top-4 right-4 z-50 ${styles.bg} text-white px-4 py-3 rounded-lg shadow-lg flex items-center space-x-3 max-w-md`}
    >
      <SafeIcon icon={styles.icon} className={`${styles.iconColor} flex-shrink-0`} />
      <span className="flex-1 text-sm font-medium">{message}</span>
      <button
        onClick={onClose}
        className="text-white hover:text-gray-200 transition-colors duration-200"
      >
        <SafeIcon icon={FiX} className="h-4 w-4" />
      </button>
    </motion.div>
  )
}

export default Toast